<script setup>
import VueMultiselect from "vue-multiselect";
import useAutocompleter from "@/composables/useAutocompleter";
import startupsService from "@/services/startups.service";
import {computed} from "vue";
import marketsService from "@/services/markets.service";

const props = defineProps({
    value: Array,
    multiple: Boolean,
    defaultList: {
        type: Array,
        default: () => []
    },
    filter: {
        type: String,
        default: ''
    },
});

const emit = defineEmits(['input']);
const {model, list, query, updateList} = useAutocompleter(props, getList, emit);

const actualList = computed(() => {
    if (query.value.length) {
        return list.value;
    } else {
        return props.defaultList;
    }
})

function getList(query) {
    if (props.filter === 'partnerships') {
        return marketsService.searchPartnershipStartups(query);
    } else {
        return startupsService.search(query);
    }
}
</script>

<template>
    <VueMultiselect
        v-model="model"
        placeholder="Select Startup"
        :options="actualList"
        :multiple="multiple"
        select-label=""
        deselect-label=""
        label="name"
        track-by="name"
        class="multiselect-mid pl-2"
        @search-change="updateList"
    />
</template>

<style scoped>

</style>
